import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withFormsy } from '@akihirotakamura/formsy-react'
import _ from 'lodash'
import { Icon, Button, BaseForm as Form, Modal } from 'component/base'
import { PageContainer, Custom } from 'component/pieces'

export const Hanbaisaki = withFormsy(props => {
  const {
    // Formsy props
    isPristine,
    errorLabel,
    getErrorMessage,
    setValue,
    getValue,

    // other
    defaultValue,
    value,
    icon,
    multiple,
    onChange,
    name,
    label,
    ichigen,
    clearable,
    ...other
  } = props

  const [showModal, setShowModal] = useState(false)
  const [savedValue, setSavedValue] = useState(value)
  const [selectedId, setSelectedId] = useState([])

  useEffect(() => {
    if (defaultValue || value) {
      setValue(defaultValue || value)
      setSavedValue(defaultValue || value)
    }
  }, [])

  useEffect(() => {
    if (!_.isEqual(value, savedValue)) {
      setValue(value)
      setSavedValue(value)
    }
  }, [value])

  const handleDecision = () => {
    setShowModal(false)
    setValue(multiple ? selectedId : selectedId[0])
    if (onChange)
      onChange(null, { value: multiple ? selectedId : selectedId[0] })
  }

  const handleChange = (e, data) => {
    setValue(data ? data.value : '')
    if (onChange) onChange(e, data, true)
  }

  return (
    <>
      <Form.Dropdown.WithAPI
        name={name}
        label={label}
        defaultValue={defaultValue}
        value={getValue()}
        url='/api/staff/master/hanbaisaki_view/slim'
        icon={
          <Icon
            name='search'
            inverted
            circular
            link
            onClick={() => {
              if (clearable && getValue()) return
              setShowModal(true)
            }}
          />
        }
        multiple={multiple}
        onChange={handleChange}
        clearable={clearable}
        editOptions={options =>
          _(options)
            .map(option => ({
              key: option.torihikisaki_id,
              value: option.torihikisaki_id,
              text: `${option.hanbaisaki_cd}：${option.hanbaisaki_name}`,
              hanbaisaki_cd: option.hanbaisaki_cd,
              dattai_date: option.dattai_date,
              label: {
                color: option.dattai_date ? 'red' : 'green',
                empty: true,
                circular: true,
              },
              image: (
                <Custom.Image.KumiaiinAvator
                  key={option.torihikisaki_id}
                  id={option.upload_files_id}
                  avatar
                />
              ),
            }))
            .value()
        }
        sort={['dattai_date', 'hanbaisaki_cd']}
        sortOrders={['desc', 'asc']}
        {...other}
      />
      {showModal && (
        <Modal
          dimmer='inverted'
          open={showModal}
          closeOnDimmerClick
          size='fullscreen'
        >
          <Modal.Header content='販売先検索' />
          <Modal.Content image scrolling>
            <Modal.Description>
              <PageContainer style={{ width: '90vw' }}>
                <Custom.Block.Hanbaisaki
                  multiple={multiple}
                  setSelectedId={setSelectedId}
                  selectedId={getValue()}
                />
              </PageContainer>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => setShowModal(false)} content='キャンセル' />
            <Button
              icon='checkmark'
              labelPosition='right'
              content='選択'
              onClick={handleDecision}
              primary
            />
          </Modal.Actions>
        </Modal>
      )}
    </>
  )
})

Hanbaisaki.propTypes = {
  keyName: PropTypes.string,
  valueName: PropTypes.string,
  textName: PropTypes.string,
}

Hanbaisaki.defaultProps = {
  keyName: 'torihikisaki_id',
  valueName: 'torihikisaki_id',
  textName: 'hanbaisaki_name',
}
